import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SICProfessionPackage  {
    _originalTypeClassName = "zERP.BO.SICProfessionPackage";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SICProfessionPackage.translate = translateService;
}
this.Id = null;
this.Type = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Type:any;
Name:any;
SIC:any;
InsuranceProfession:any;
InsuranceCoveragePackage:any;
static setSIC = ($this, value) => {
var oldValue = $this.SIC;
$this.SIC = value;
if (value != null) {
}
}
static setInsuranceProfession = ($this, value) => {
var oldValue = $this.InsuranceProfession;
$this.InsuranceProfession = value;
if (value != null) {
if (oldValue != null) {
Domain.InsuranceProfession.removePackages(oldValue, $this);
}
Domain.InsuranceProfession.addPackages(value, $this);
}
}
static setInsuranceCoveragePackage = ($this, value) => {
var oldValue = $this.InsuranceCoveragePackage;
$this.InsuranceCoveragePackage = value;
if (value != null) {
if (oldValue != null) {
Domain.InsuranceCoveragePackage.removeProfessions(oldValue, $this);
}
Domain.InsuranceCoveragePackage.addProfessions(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}